"use client";

import Image from "next/image";
import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";

export default function SignInClient() {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") || "/";
  const error = searchParams.get("error");

  const errorMessage =
    error === "OAuthCallback"
      ? "Échec du retour d’authentification. Vérifiez la configuration du client Keycloak et réessayez."
      : error
      ? "Une erreur d’authentification est survenue. Veuillez réessayer."
      : null;

  return (
    <main className="signin-page">
      <div className="signin-card">
        <div className="signin-header">
          <Image
            src="/images/ub-logo.png"
            alt="Logo Université de Bangui"
            width={96}
            height={96}
            className="signin-logo"
            priority
          />

          <h1>Plateforme LiveKit – EDST</h1>

          <p className="subtitle">
            Connexion sécurisée à la plateforme de visioconférence de l’Université de Bangui.
          </p>

          <div className="ticker-wrapper">
            <div className="ticker">
              <span>
                Bienvenue sur la plateforme de visioconférence sécurisée •
                Authentification centralisée SSO •
                Accès réservé aux utilisateurs autorisés •
                EDST – Université de Bangui
              </span>
            </div>
          </div>
        </div>

        {errorMessage && <div className="error-box">{errorMessage}</div>}

        <button
          className="signin-button"
          onClick={() => signIn("keycloak", { callbackUrl })}
        >
          Se connecter via la plateforme SSO EDST
        </button>

        <p className="hint">
          Après authentification, vous serez redirigé automatiquement vers l’interface Meet.
        </p>
      </div>

      <style jsx>{`
        .signin-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
          background:
            radial-gradient(circle at top left, rgba(37, 99, 235, 0.14), transparent 32%),
            radial-gradient(circle at bottom right, rgba(22, 163, 74, 0.12), transparent 28%),
            linear-gradient(135deg, #eef2ff 0%, #f8fafc 45%, #e5e7eb 100%);
        }

        .signin-card {
          width: 100%;
          max-width: 760px;
          background: rgba(255, 255, 255, 0.92);
          border: 1px solid rgba(255, 255, 255, 0.6);
          backdrop-filter: blur(10px);
          border-radius: 24px;
          padding: 40px 34px;
          box-shadow: 0 20px 60px rgba(15, 23, 42, 0.16);
        }

        .signin-header {
          text-align: center;
        }

        .signin-logo {
          margin: 0 auto 18px auto;
          border-radius: 12px;
          background: #fff;
          padding: 6px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
        }

        h1 {
          margin: 0 0 10px 0;
          font-size: 2.2rem;
          line-height: 1.2;
          font-weight: 800;
          color: #0f172a;
        }

        .subtitle {
          margin: 0 auto 20px auto;
          max-width: 620px;
          font-size: 1.05rem;
          line-height: 1.8;
          color: #475569;
        }

        .ticker-wrapper {
          overflow: hidden;
          border-radius: 12px;
          background: linear-gradient(90deg, #0f172a, #1e293b);
          color: #fff;
          height: 48px;
          display: flex;
          align-items: center;
          margin: 24px 0 28px 0;
          border: 1px solid rgba(255, 255, 255, 0.08);
        }

        .ticker {
          white-space: nowrap;
          display: inline-block;
          min-width: 100%;
          animation: scroll-left 20s linear infinite;
          padding-left: 100%;
        }

        .ticker-wrapper:hover .ticker {
          animation-play-state: paused;
        }

        .ticker span {
          font-size: 0.98rem;
          font-weight: 600;
          letter-spacing: 0.2px;
        }

        .error-box {
          margin: 0 0 20px 0;
          padding: 14px 16px;
          border-radius: 12px;
          background: #fee2e2;
          color: #991b1b;
          border: 1px solid #fecaca;
          font-size: 0.97rem;
          line-height: 1.6;
        }

        .signin-button {
          width: 100%;
          border: none;
          border-radius: 14px;
          padding: 16px 20px;
          font-size: 1.08rem;
          font-weight: 700;
          color: #fff;
          cursor: pointer;
          background: linear-gradient(135deg, #2563eb, #1d4ed8);
          box-shadow: 0 12px 24px rgba(37, 99, 235, 0.28);
          transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
        }

        .signin-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 16px 28px rgba(37, 99, 235, 0.32);
          opacity: 0.97;
        }

        .hint {
          margin: 18px 0 0 0;
          text-align: center;
          color: #64748b;
          font-size: 0.95rem;
        }

        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        @media (max-width: 768px) {
          .signin-card {
            padding: 28px 20px;
            border-radius: 20px;
          }

          h1 {
            font-size: 1.7rem;
          }

          .subtitle {
            font-size: 0.98rem;
          }
        }
      `}</style>
    </main>
  );
}
